// BL-177 Step 3: scheduled messages as bubbles in a conversation.
//   scheduled / sending -> the purple dashed "Scheduled" bubble (a message that is being sent right now still shows until it lands)
//   failed              -> a red "Not delivered" bubble with the reason (no Retry: a scheduled message is never re-sent automatically)
//   cancelled by the system (opted out, they replied first) -> a grey dashed "Cancelled" bubble with the reason
//   cancelled by a person -> nothing; sent -> normal confirmed bubble until the canonical log arrives
// A scheduled message that already appears as a real message (same client_ref) is dropped, so it never shows twice while it lands.

const SYSTEM_CANCEL = /^Cancelled\s+[–-]/;

function stamp(value) {
    const time = Date.parse(value || '');
    return Number.isFinite(time) ? time : null;
}

export function buildScheduledThreadItems(rows = [], existingItems = []) {
    const realRefs = new Set(existingItems.map((item) => item?.clientRef).filter(Boolean));
    return (Array.isArray(rows) ? rows : []).flatMap((row) => {
        if (!row || realRefs.has(row.client_ref)) return [];
        const base = {
            id: `scheduled-${row.id}`, kind: 'message', source: 'scheduled', direction: 'outbound', role: 'staff', channel: row.channel,
            text: row.body || (row.content_sid ? 'Message template' : ''), staffUserId: row.created_by, clientRef: row.client_ref,
            media: [], mediaKeys: [], mediaUrls: [], pending: false, scheduledRow: row, scheduled_for: row.scheduled_for,
        };
        if (row.status === 'scheduled' || row.status === 'sending') {
            // `at` stays empty: a future time must not stretch the conversation's time span; the bubble shows scheduled_for
            return [{ ...base, at: null, scheduled: true, provider_status: 'scheduled' }];
        }
        if (row.status === 'sent') {
            return [{ ...base, at: stamp(row.sent_at || row.updated_at), provider_status: 'sent' }];
        }
        if (row.status === 'failed') {
            return [{ ...base, at: stamp(row.updated_at), provider_status: 'failed', provider_error_message: row.status_reason || 'The scheduled message could not be sent.' }];
        }
        if (row.status === 'cancelled' && SYSTEM_CANCEL.test(row.status_reason || '')) {
            return [{ ...base, at: stamp(row.updated_at), scheduled_cancelled: true }];
        }
        return [];
    });
}
